import AccessDenied from '@common/containers/accessDenied/accessDenied.container';
import LayoutContainer from '@common/containers/layout/layout.withMenu';
import acValidation from '@common/validators/accessControl.validator';

export default function execute(nextRoute, currentRoute) {
  if (nextRoute.accessControl) {
    const routeValidate = nextRoute.accessControlRoute || nextRoute.name;
    if (!acValidation.checkPermissionByNameAndIdSistema(routeValidate))
      return {
        ...nextRoute,
        component: AccessDenied,
      };
  }

  return nextRoute;
}
